import { DOSYA_DURUMLARI } from "./choices";
import { DK_ASAMALARI } from "./degerKaybiApi";

/**
 * Liste sayfası gelişmiş filtre tanımları.
 * queryKey: API query param adı (varsayılan key ile aynı).
 */
export const ENTITY_LIST_FILTERS = {
    "sigorta-dosyalari": [
        {
            key: "dosya_durumu",
            label: "Dosya durumu",
            type: "select",
            options: DOSYA_DURUMLARI,
        },
        {
            key: "avukat",
            label: "Avukat",
            type: "fk",
            resource: "kullanicilar",
            labelKeys: ["username", "first_name", "last_name"],
        },
        {
            key: "kaza_tarihi_after",
            label: "Kaza tarihi (başlangıç)",
            type: "date",
        },
        {
            key: "kaza_tarihi_before",
            label: "Kaza tarihi (bitiş)",
            type: "date",
        },
        {
            key: "bekleyen_not",
            label: "Bekleyen operasyon notu",
            type: "select",
            options: [{ value: "1", label: "Evet — halledilmemiş not var" }],
        },
        {
            key: "on_tahkim_sure_durumu",
            label: "Başvuru SLA durumu",
            type: "select",
            options: [
                { value: "BEKLIYOR", label: "Bekliyor" },
                { value: "YAKLASIYOR", label: "Yaklaşıyor (≤3 gün)" },
                { value: "HAZIR", label: "Hazır — bugün" },
                { value: "GECIKTI", label: "Gecikmiş" },
            ],
        },
        {
            key: "on_tahkim_gecis_modu",
            label: "Geçiş modu",
            type: "select",
            options: [
                { value: "OTOMATIK", label: "Otomatik ön tahkim" },
                { value: "MANUEL", label: "Manuel onay" },
            ],
        },
        {
            key: "gecis_aksiyon",
            label: "Onay bekleyen",
            type: "select",
            options: [{ value: "onay_bekliyor", label: "Manuel — ön tahkime geçirilmeyi bekliyor" }],
        },
    ],
    "deger-kaybi": [
        {
            key: "dk_asama",
            label: "DK aşaması",
            type: "select",
            options: DK_ASAMALARI,
        },
        {
            key: "hesaplanmamis",
            label: "Hesaplanmamış",
            type: "select",
            options: [{ value: "1", label: "Evet — rayiç/DK/parça eksik" }],
        },
        {
            key: "tahsil_edilmemis",
            label: "Tahsil edilmemiş",
            type: "select",
            options: [{ value: "1", label: "Evet — DK tahsilatı eksik" }],
        },
        {
            key: "rayic_min",
            label: "Rayiç min (₺)",
            type: "number",
        },
        {
            key: "rayic_max",
            label: "Rayiç max (₺)",
            type: "number",
        },
        {
            key: "dk_min",
            label: "DK min (₺)",
            type: "number",
        },
        {
            key: "dk_max",
            label: "DK max (₺)",
            type: "number",
        },
        {
            key: "dosya_durumu",
            label: "Dosya durumu",
            type: "select",
            options: DOSYA_DURUMLARI,
        },
        {
            key: "kaza_tarihi_after",
            label: "Kaza tarihi (başlangıç)",
            type: "date",
        },
        {
            key: "kaza_tarihi_before",
            label: "Kaza tarihi (bitiş)",
            type: "date",
        },
    ],
    "tahkim-dosyalari": [
        {
            key: "dosya_durumu",
            label: "Durum",
            type: "select",
            options: DOSYA_DURUMLARI,
        },
        {
            key: "tahkim_asamasi",
            label: "Tahkim aşaması",
            type: "select",
            options: [
                { value: "ON_TAHKIM", label: "Ön Tahkim" },
                { value: "BASVURU", label: "Başvuru" },
                { value: "HAKEM", label: "Hakem" },
                { value: "BILIRKISI", label: "Bilirkişi" },
                { value: "ARA_KARAR", label: "Ara Karar" },
                { value: "KARAR", label: "Karar" },
                { value: "ODEME", label: "Ödeme" },
                { value: "KAPANDI", label: "Kapandı" },
            ],
        },
        {
            key: "odeme_durumu",
            label: "Ödeme",
            type: "select",
            options: [
                { value: "BEKLIYOR", label: "Bekliyor" },
                { value: "ODENDI", label: "Ödendi" },
                { value: "GECIKTI", label: "Gecikti" },
                { value: "IPTAL", label: "İptal" },
            ],
        },
        {
            key: "hatirlatma",
            label: "Hatırlatma",
            type: "select",
            options: [
                { value: "geciken_odeme", label: "Geciken ödeme" },
                { value: "yakin_odeme", label: "7 gün içinde ödeme" },
                { value: "hakem_bekliyor", label: "Hakem bekliyor" },
            ],
        },
    ],
    muvekkiller: [
        {
            key: "vekalet_durumu",
            label: "Vekalet durumu",
            type: "select",
            options: [
                { value: "ALINDI", label: "Alındı" },
                { value: "ALINMADI", label: "Alınmadı" },
            ],
        },
        {
            key: "kimlik_tipi",
            label: "Kimlik türü",
            type: "select",
            options: [
                { value: "TC", label: "T.C. Kimlik" },
                { value: "VERGI", label: "Vergi No" },
            ],
        },
    ],
    odemeler: [
        {
            key: "odeme_turu",
            label: "Ödeme türü",
            type: "select",
            options: [
                { value: "ON_ODEME", label: "Ön Ödeme" },
                { value: "GELEN_ODEME", label: "Gelen Ödeme" },
                { value: "ICRA_TAHSILAT", label: "İcra Tahsilatı" },
                { value: "ICRA_MASRAF", label: "İcra Masrafı" },
            ],
        },
        {
            key: "odeme_yapildi",
            label: "Ödeme durumu",
            type: "select",
            options: [
                { value: "false", label: "Bekleyen" },
                { value: "true", label: "Ödendi" },
            ],
        },
        {
            key: "icra_takibi",
            label: "İcra dosyası",
            type: "fk",
            resource: "icralar",
            labelKeys: ["icra_dosya_no", "sigorta_dosyasi_label"],
        },
    ],
    icralar: [
        {
            key: "dosya_durumu",
            label: "Durum",
            type: "select",
            options: [
                { value: "BASLATILDI", label: "Başlatıldı" },
                { value: "TAKIPTE", label: "Takipte" },
                { value: "TAHSIL_EDILDI", label: "Tahsil Edildi" },
                { value: "KAPANDI", label: "Kapandı" },
            ],
        },
        {
            key: "tahsil_bekleyen",
            label: "Tahsil bekleyen",
            type: "select",
            options: [{ value: "1", label: "Evet" }],
        },
    ],
    "dava-dosyalari": [
        {
            key: "dosya_durumu",
            label: "Durum",
            type: "select",
            options: DOSYA_DURUMLARI,
        },
    ],
    randevular: [
        {
            key: "durum",
            label: "Durum",
            type: "select",
            options: [
                { value: "planlandi", label: "Planlandı" },
                { value: "tamamlandi", label: "Tamamlandı" },
                { value: "iptal", label: "İptal" },
            ],
        },
        {
            key: "baslangic_after",
            label: "Başlangıç (min)",
            type: "date",
        },
        {
            key: "baslangic_before",
            label: "Başlangıç (max)",
            type: "date",
        },
    ],
    evraklar: [
        {
            key: "onay_durumu",
            label: "Onay durumu",
            type: "select",
            options: [
                ["BEKLIYOR", "Bekliyor"],
                ["ONAYLI", "Onaylı"],
                ["REDDEDILDI", "Reddedildi"],
            ],
        },
        {
            key: "portal_kaynak",
            label: "Kaynak",
            type: "select",
            options: [
                ["1", "Müvekkil portalı"],
                ["0", "MBS / ofis"],
            ],
        },
    ],
    hatirlatmalar: [
        {
            key: "hatirlatma_zamani_after",
            label: "Hatırlatma (min)",
            type: "date",
        },
        {
            key: "hatirlatma_zamani_before",
            label: "Hatırlatma (max)",
            type: "date",
        },
    ],
};

export function getListFilters(entityKey) {
    return ENTITY_LIST_FILTERS[entityKey] || [];
}

export function countActiveFilters(filters, values) {
    if (!filters.length) return 0;
    return filters.filter((f) => {
        const v = values[f.key];
        return v !== undefined && v !== null && String(v).trim() !== "";
    }).length;
}
